import { useState, useEffect } from "react"
import { TextField } from "@material-ui/core"
import {
    obtenerPaquetesAllAction,
    clearPaquetesState,
} from "./../../ducks/paqueteDuck"
import { useDispatch, useSelector } from "react-redux"
import { onLoadAnction, offLoadAction } from "../../ducks/loadDuck"

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value)
        }, delay)

        return () => {
            clearTimeout(handler)
        }
    }, [value, delay])

    return debouncedValue
}

const FBusqueda = (props) => {
    const { label = "Buscar" } = props
    const dispatch = useDispatch()
    const [buscador, setBuscador] = useState("0")
    const debouncedInput = useDebounce(buscador, 500); // 500ms de retraso
    const busqueda = useSelector(store => store.paquetes.busqueda)
    useEffect(() => {
        if (debouncedInput) {
            dispatch(onLoadAnction({message: ""}))
            dispatch(obtenerPaquetesAllAction(debouncedInput)).then((Response) => {
                dispatch(offLoadAction())
            })
        }
        return () => {
            dispatch(clearPaquetesState())
        }
    }, [debouncedInput])

    const onChange = (event) => {
        setBuscador((event.target.value.length > 0) ? event.target.value : "")
    }
    return (
        <TextField
            id="FielBusqueda"
            label={label}
            variant="outlined"
            name="busqueda"
            style={{ width: "100%", margin: "5px 0" }}
            value={(buscador === "0") ? "" : buscador}
            onChange={(e) => onChange(e)}
        />
    )
}
export default FBusqueda;